class Multimap {
  constructor() {
    this.map = {};
  }

  add(key, value) {
    if (!(key in this.map)) {
      this.map[key] = [];
    }
    this.map[key].push(value);
  }

  get(key) {
    return this.map[key];
  }

  has(key) {
    return key in this.map;
  }

  delete(key) {
    delete this.map[key];
  }

  clear() {
    this.map = {};
  }
}

export default Multimap;
